export default __webpack_public_path__ + "static/media/Tution.aba33900.svg";